import { Box } from '@mui/material'
import React, { PropsWithChildren } from 'react'
import { connect } from 'react-redux'
import {
  Operations as LayoutOperations,
  operations as layoutOperations
} from 'states/dux/layout/operations'
import { Payload as LayoutPayload } from 'states/dux/layout/types'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import State from 'states/types'
import { mapOperationsToDispatchProps } from 'utils/common'

interface StateProps {
  theme: ThemePayload
  layout: LayoutPayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
    layout: LayoutOperations
  }
}

type AppProps = StateProps & DispatchProps & PropsWithChildren

const NivosPublicLayoutFC: React.FC<any> = (props: AppProps) => {
  const { theme, children } = props
  return (
    <Box bgcolor={theme.primaryColor} minHeight={'100vh'}>
      {children}
    </Box>
  )
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme,
    layout: state.layout
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations,
  layout: layoutOperations
})

const NivosPublicLayout = connect(
  mapStateToProps,
  mapDispatchToProps
)(NivosPublicLayoutFC) as React.FC<PropsWithChildren>

export default NivosPublicLayout
